module.exports = __webpack_public_path__ + "static/media/rusafa.2ce85451.jpg";